import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../Context/AuthProvider";
import LoadingSpinner from "../LoadingSpinner";

const ProtectedRoute = ({ children }) => {
  const { isLoading, userData, handleLogin } = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !userData) {
      const target = location.pathname + location.search;
      try {
        localStorage.setItem("postLoginRedirect", target);
      } catch (e) {}
      handleLogin(target);
    }
  }, [isLoading, userData, handleLogin, location]);

  if (isLoading) return <LoadingSpinner />;
  if (userData) return children;
  return null;
};

export default ProtectedRoute;
